import script from "./UserDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDashboard.vue?vue&type=script&setup=true&lang=js"

import "./UserDashboard.vue?vue&type=style&index=0&id=cc1dd3be&scoped=true&lang=scss"

import exportComponent from "D:\\DongLK\\Project\\ytbot\\controller-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc1dd3be"]])

export default __exports__